let tooltipID;
const websiteMinimumOuterWidth = 768;

$(document).ready(function () {
    $(document).on('mouseenter', '[data-js-tooltip]', function () {
        if ($(window).outerWidth() >= websiteMinimumOuterWidth) {
            tooltipID = Math.floor(Math.random() * 10000) + 1;
            $(this).attr('aria-describedby', `tooltip${tooltipID}`);
            addTooltip($(this));
        }
    });

    $(document).on('mouseleave', '[data-js-tooltip]', function () {
        $(this).removeAttr('aria-describedby');
        var tooltipText = $(`#tooltip${tooltipID}`);
        tooltipText.removeClass('tooltip-show');
        setTimeout(function () {
            tooltipText.remove();
        }, 25);
    });
});

function addTooltip (tooltipHover) {
    var arrowPadding = 8;
    var hoverOffset = tooltipHover.offset();
    var tooltipTextData = tooltipHover.data('js-tooltip');
    var tooltipID = tooltipHover.attr('aria-describedby');

    var tooltipText = $("<div>", {
        "class": `tooltip-wrapper`,
        "css": {
            top: 0,
            left: 0,
            display: 'none',
        },
        "id": `${tooltipID}`,
    });

    var tooltipTextHtml =
    `
        <div class="tooltip-text">
        ${tooltipTextData}
        </div>

        <div class="tooltip-arrow">
        </div>
    `
    ;

    tooltipText.append(tooltipTextHtml);
    $('body').append(tooltipText);

    //setTimeout => musi se pockat nez se aplikuji css na tooltipText, jinak to vraci nespravne vysku,sirku (protoze se az po par milisekundach prida padding, font-family atd...)
    setTimeout(function () {
        var spaceFromLeft = hoverOffset.left - $(window).scrollLeft();
        var spaceFromRight = $(window).innerWidth() - (spaceFromLeft + tooltipHover.outerWidth());
        var spaceFromBottom = ($(window).innerHeight() + $(window).scrollTop()) - hoverOffset.top - tooltipHover.outerHeight();
        var spaceFromTop = hoverOffset.top - $(window).scrollTop();

        var tooltipTextWidthOverTooltipHover = (tooltipText.outerWidth() - tooltipHover.outerWidth()) / 2; //o kolik px presahuje zleva/zprava tooltipText pres tooltipHover, jestlize je zaporne, tak je tooltipHover.outerWidth > tooltipText.outerWidth()
        var tooltipTextHeightOverTooltipHover = (tooltipText.outerHeight() - tooltipHover.outerHeight()) / 2; //o kolik px presahuje zleva/zprava tooltipText pres tooltipHover, jestlize je zaporne, tak je tooltipHover.outerWidth > tooltipText.outerWidth()

        var fitsTop_Height = spaceFromTop > tooltipText.outerHeight(); //tooltipText se vleze na vysku nad tooltipHover (netrci ven z window)
        var fitsBottom_Height = spaceFromBottom > tooltipText.outerHeight(); //tooltipText se vleze na vysku pod tooltipHover (netrci ven z window)
        var fitsLeft_Height = spaceFromTop > tooltipTextHeightOverTooltipHover; //tooltipText se vleze na vysku vlevo od tooltipHover (neni sirsi jak tooltipHover)
        var fitsRight_Height = spaceFromBottom > tooltipTextHeightOverTooltipHover; //tooltipText se vleze na vysku vlevo pod tooltipHover (neni sirsi jak tooltipHover)
        var fitsLeftAndRightHeight = fitsLeft_Height && fitsRight_Height;

        var fitsTop_Width = spaceFromLeft > tooltipTextWidthOverTooltipHover; //tooltipText se vleze na vysku vlevo od tooltipHover (neni vyssi jak tooltipHover)
        var fitsBottom_Width = spaceFromRight > tooltipTextWidthOverTooltipHover; //tooltipText se vleze na vysku vpravo od tooltipHover (neni vyssi jak tooltipHover)
        var fitsLeft_Width = spaceFromLeft > tooltipText.outerWidth(); //tooltipText se vleze na sirku vlevo od tooltipHover (netrci ven z window)
        var fitsRight_Width = spaceFromRight > tooltipText.outerWidth(); //tooltipText se vleze na sirku vpravo od tooltipHover (netrci ven z window)
        var fitsTopAndBottomWidth = fitsTop_Width && fitsBottom_Width;

        var translateOffsetLeft = 0;
        var translateOffsetTop = 0;
        var arrowOrientation = null;
        var isTooltipCentered = true;
        var tooltipArrowDiv = $('.tooltip-arrow');

        if (fitsTop_Height && fitsTopAndBottomWidth) //tooltipText se vejde vycentrovany nad tooltipHover
        {
            arrowOrientation = 'width';
            tooltipArrowDiv.addClass('tooltip-arrow--bottom');
            translateOffsetLeft = hoverOffset.left - tooltipTextWidthOverTooltipHover;
            translateOffsetTop = hoverOffset.top - tooltipText.outerHeight() - arrowPadding;

        } else if (fitsBottom_Height && fitsTopAndBottomWidth) //tooltipText se vejde vycentrovany pod tooltipHover
        {
            arrowOrientation = 'width';
            tooltipArrowDiv.addClass('tooltip-arrow--top');
            translateOffsetLeft = hoverOffset.left - tooltipTextWidthOverTooltipHover;
            translateOffsetTop = hoverOffset.top + tooltipHover.outerHeight() + arrowPadding;
        }
        else if (fitsLeft_Width && fitsLeftAndRightHeight) //tooltipText se vejde vycentrovany nalevo od tooltipHover
        {
            arrowOrientation = 'height';
            tooltipArrowDiv.addClass('tooltip-arrow--right');
            translateOffsetLeft = hoverOffset.left - tooltipText.outerWidth() - arrowPadding;
            translateOffsetTop = hoverOffset.top - (tooltipText.outerHeight() / 2) + (tooltipHover.outerHeight() / 2);

        } else if (fitsRight_Width && fitsLeftAndRightHeight) //tooltipText se vejde vycentrovany napravo od tooltipHover
        {
            arrowOrientation = 'height';
            tooltipArrowDiv.addClass('tooltip-arrow--left');
            translateOffsetLeft = hoverOffset.left + tooltipHover.outerWidth() + arrowPadding;
            translateOffsetTop = hoverOffset.top - (tooltipText.outerHeight() / 2) + (tooltipHover.outerHeight() / 2);
        }
        else if (fitsTop_Height) { //tooltipText se vejde nevycentrovany nad tooltipHover
            arrowOrientation = 'width';
            isTooltipCentered = false;
            tooltipArrowDiv.addClass('tooltip-arrow--bottom');
            if (spaceFromLeft <= spaceFromRight) { //tooltipText se zarovnava k levemu okraji stranky
                translateOffsetLeft = $(window).scrollLeft();
            } else {  //tooltipText se zarovnava k pravemu okraji stranky
                translateOffsetLeft = hoverOffset.left - (hoverOffset.left + tooltipText.outerWidth() - $(window).scrollLeft() - $(window).innerWidth());
            }
            translateOffsetTop = hoverOffset.top - tooltipText.outerHeight() - arrowPadding;

        } else if (fitsBottom_Height) { //tooltipText se vejde nevycentrovany pod tooltipHover
            arrowOrientation = 'width';
            isTooltipCentered = false;
            tooltipArrowDiv.addClass('tooltip-arrow--top');
            if (spaceFromLeft <= spaceFromRight) { //tooltipText se zarovnava k levemu okraji stranky
                translateOffsetLeft = $(window).scrollLeft();
            } else { //tooltipText se zarovnava pravemu okraji stranky
                translateOffsetLeft = hoverOffset.left - (hoverOffset.left + tooltipText.outerWidth() - $(window).scrollLeft() - $(window).innerWidth());
            }
            translateOffsetTop = hoverOffset.top + tooltipHover.outerHeight() + arrowPadding;
        } else {
            console.log('tooltip se nevejde na web');
        }

        tooltipText.css({
            transform: `translate(${translateOffsetLeft}px, ${translateOffsetTop}px)`,
        });

        function setTooltipArrowPosition(orientation, isTooltipCentered = true) {
            var arrowSpace = 10 / 2; //delka strany ctverce v tooltip-arrow::before
            var translateX = 0;
            var translateY = 0;

            if (orientation === 'width') { //je tooltip nad(width) nebo vedle(height) tooltipHover ?
                if (isTooltipCentered === true) { //je toolip vycentrovany nad tooltipHover ?
                    if (tooltipTextWidthOverTooltipHover > 0) {
                        translateX = hoverOffset.left - tooltipText.offset().left + (tooltipHover.outerWidth() / 2) - arrowSpace;
                    } else {
                        translateX = (tooltipText.outerWidth() / 2) - arrowSpace;
                    }
                } else {
                    if (spaceFromLeft >= spaceFromRight) { //zarovnava se tooltip k levemu nebo pravemu okraji?
                        if (spaceFromRight >= 0) {
                            translateX = tooltipText.outerWidth() - spaceFromRight - (tooltipHover.outerWidth() / 2) - arrowSpace;
                        } else {
                            translateX = tooltipText.outerWidth() - ((tooltipHover.outerWidth() + spaceFromRight) / 2) - arrowSpace;
                        }
                    } else {
                        if (spaceFromLeft >= 0) {
                            translateX = ((tooltipHover.outerWidth() / 2) + spaceFromLeft - arrowSpace);
                        } else {
                            translateX = (((tooltipHover.outerWidth() + spaceFromLeft) / 2) - arrowSpace);
                        }
                    }
                }

                tooltipArrowDiv.css({
                    transform: `translateX(${translateX}px)`,
                });
            } else {
                translateY = -((tooltipText.outerHeight() / 2) - arrowSpace);

                tooltipArrowDiv.css({
                    transform: `translateY(${translateY}px)`,
                });
            }
        }

        tooltipText.css({
            display: 'inline-block',
        });
        setTooltipArrowPosition(arrowOrientation, isTooltipCentered);
        tooltipText.addClass('tooltip-show');

        /*
        console.log('------------------------DEBUGGING---------------------------');
        console.log('OFFSET TOP', hoverOffset.top);
        console.log('OFFSET LEFT', hoverOffset.left);
        console.log('WINDOW OUTER HEIGHT', $(window).outerHeight());
        console.log('WINDOW OUTER WIDTH:', $(window).outerWidth());
        console.log('WINDOW INNER HEIGHT', $(window).innerHeight());
        console.log('WINDOW INNER WIDTH:', $(window).innerWidth());
        console.log('WINDOW WIDTH', $(window).width());

        console.log('DOCUMENT OUTER HEIGHT:', $(document).outerHeight());
        console.log('DOCUMENT OUTER WIDTH:', $(document).outerWidth());
        console.log('DOCUMENT INNER HEIGHT:', $(document).innerHeight());
        console.log('DOCUMENT INNER WIDTH:', $(document).innerWidth());

        console.log('scrolled from top', $(window).scrollTop());
        console.log('scrolled from left', $(window).scrollLeft());

        console.log('TOOLTIP TRIGGER WIDTH', tooltipHover.outerWidth());
        console.log('TOOLTIP TRIGGER HEIGHT', tooltipHover.outerHeight());
        console.log('TOOLTIP TEXTBOT WIDTH', tooltipText.outerWidth());
        console.log('TOOLTIP TEXTBOT HEIGHT', tooltipText.outerHeight());

        console.log('prostor ze shora', spaceFromTop);
        console.log('prostor ze spoda', spaceFromBottom);
        console.log('prostor zleva', spaceFromLeft);
        console.log('prostor zprava', spaceFromRight);

        console.log('fitsTop_height', fitsTop_Height);
        console.log('fitsBottom_height', fitsBottom_Height);
        console.log('fitsLeft_width', fitsLeft_Width);
        console.log('fitsRight_width', fitsRight_Width);
        console.log('o kolik px presahuje tooltipText tooltipHover na sirku', tooltipTextWidthOverTooltipHover);
        console.log('fitsTopAndBottomWidth', fitsTopAndBottomWidth);
        console.log('o kolik px presahuje tooltipText tooltipHover na vysku', tooltipTextHeightOverTooltipHover);
        console.log('fitsLeftAndRightHeight', fitsLeftAndRightHeight);
        console.log('------------------------END DEBUGGING---------------------------');
        */
    }, 25);
}
